export var COMPETITION_GAME = 'Competition';
export var PRODUCTS = 'Trackables';
export var PRODUCT = 'Trackable';
export var TRACKING_GAME = 'Tracking';
var LanguageConstants = {
    COMPETITION_GAME: COMPETITION_GAME,
    PRODUCTS: PRODUCTS,
    PRODUCT: PRODUCT,
    TRACKING_GAME: TRACKING_GAME
};
export default LanguageConstants;
